'use client';

import clsx from 'clsx';
import { FC } from 'react';
import { shallow } from 'zustand/shallow';

import { Icon } from '@/general/Icons/Icon';
import { Button } from '@/general/components/Button/Button';
import { ButtonIcon } from '@/general/components/Button/ButtonIcon';
import { useFormStepTransition } from '@/general/transitions/FormStepTransition/FormStepTransition.context';
import { stepFormStore } from '@/steps-form/stepFormStore';

type Props = {
  className?: string;
};

export const AuthFormBack: FC<Props> = ({ className }) => {
  const { onBack } = stepFormStore(
    (state) => ({
      onBack: state.onBack,
    }),
    shallow,
  );
  const { navigate } = useFormStepTransition();
  const clickBack = onBack
    ? () => {
        typeof onBack === 'function' ? onBack() : navigate(onBack, true);
      }
    : undefined;

  if (!onBack) return null;

  return (
    <div className={clsx(className)}>
      <div className="-mt-2 -ml-3.5 sm:hidden">
        <ButtonIcon
          icon={<Icon name="arrow-left" />}
          onClick={clickBack}
          title="Back"
          variant="tertiary"
          size="small"
          data-testid="AuthFormHeader-component-backIcon"
        />
      </div>
      <div className="hidden sm:inline-flex">
        <Button
          startIcon={<Icon name="arrow-left" />}
          onClick={clickBack}
          variant="tertiary"
          data-testid="AuthFormHeader-component-backButton"
        >
          Back
        </Button>
      </div>
    </div>
  );
};
